export enum MenuSection {
  Colors = 'colors',
  ComponentSpecificProperties = 'component-specific-properties', // not a proper MenuSection, references a ComponentCard
  CupolaProperties = 'cupola-properties', // not a proper MenuSection, references the cupola ComponentCard
  Custom = 'custom',
  Details = 'details',
  DoorsWindows = 'doors-windows',
  Flooring = 'flooring', // not a proper MenuSection, references a submenu of FlooringInterior
  FlooringInterior = 'flooring-interior',
  Information = 'information',
  Interior = 'interior', // not a proper MenuSection, references a submenu of FlooringInterior
  Materials = 'material',
  None = 'none', // not a proper MenuSection, used as state to track when no menu selected
  Packages = 'packages',
  RoofSnoopProperties = 'roof-snoop-properties', // not a proper MenuSection, references the roof-snoop ComponentCard
  SalesTools = 'sales-tools',
  SectionsProps = 'sections-props',
  ServicesFinancing = 'services-financing',
  Size = 'size',
  Style = 'style',
}
